// Do not export index.ts - instead extend in every repository which uses this enum
export enum PaymentFrequency {
  Daily = 'DAILY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Single = 'SINGLE',
  Yearly = 'YEARLY',
}
